import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-vsr-customers.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "The Benefits: Extend Your Sales Team, Amplify Marketing ROI";

const Benefits = () => (
  <HeroSection title={title} className="sm:py-16 lg:py-20">
    <div className="grow flex flex-col items-center">
      <HeroSection.Content className="w-full md:text-center mb-16">
        <HeroSection.Header>
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
      </HeroSection.Content>
      <HeroSection.Content className="w-full flex flex-col text-left lg:flex-row lg:items-center gap-x-10 gap-y-8 mb-14">
        <div className="flex-1 space-y-6">
          <p className="text-lg">
            <strong>Enerflo VSR helps you do more with less</strong> — empowering your marketing and sales teams with
            automation that works around the clock.
          </p>
          <ul className="list-disc list-outside space-y-6 ml-4">
            <li>
              <strong>Extend your reach:</strong> Capture and qualify leads even when your sales team is off the clock.
            </li>
            <li>
              <strong>Save time and resources:</strong> Eliminate repetitive manual qualification steps on the front
              end.
            </li>
            <li>
              <strong>Maximize marketing ROI:</strong> Turn your paid ads, referral traffic, and organic visitors into
              measurable, qualified leads.
            </li>
            <li>
              <strong>Enhance homeowner experience:</strong> Give prospects an easy, pressure-free way to explore solar
              on their terms.
            </li>
          </ul>
        </div>

        <figure className="flex-1 w-full xs:w-4/5 sm:w-3/4 md:w-1/2 lg:w-full mx-auto">
          <Image
            src={FigureImage}
            alt="Enerflo Virtual Sales Rep (VSR): Homeowners Solar Shopping Online."
            layout="responsive"
            quality={100}
            placeholder="blur"
            className="crispImage"
            sizes="(min-width: 768px) 50vw, 100vw"
          />
        </figure>
      </HeroSection.Content>
      <HeroSection.Content className="w-full md:text-center">
        <strong>
          With Enerflo VSR, every click, every visit, and every campaign has the potential to convert — even while you
          sleep.
        </strong>
      </HeroSection.Content>
    </div>
  </HeroSection>
);

export default Benefits;
